import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button, Icon } from '@innovationnorway/cl-react';

function ResetFilterButton({ onClick, className }: { onClick: () => void; className?: string }) {
  const { t } = useTranslation('buttons');
  return (
    <Button className={className} onClick={onClick} variant="tertiary" type="button">
      <Icon prefix="fasr" iconName="redo" className="in-button--icon" />
      {t('clearFilter')}
    </Button>
  );
}

export default ResetFilterButton;
